import { createLucideIcon } from "lucide-react";

/** Six bricks stacked in three courses: three, two, then one. */
export const StackedBricksIcon = createLucideIcon("stacked-bricks", [
  ["rect", { x: "2", y: "16", width: "20", height: "5", rx: "0.5", key: "bottom" }],
  ["path", { d: "M8.67 16v5M15.33 16v5", key: "bottom-joints" }],
  ["rect", { x: "5.33", y: "10", width: "13.34", height: "5", rx: "0.5", key: "middle" }],
  ["path", { d: "M12 10v5", key: "middle-joint" }],
  ["rect", { x: "8.67", y: "4", width: "6.66", height: "5", rx: "0.5", key: "top" }],
]);

/** Tower crane with a braced mast, lattice jib and hanging hook. */
export const TowerCraneIcon = createLucideIcon("tower-crane", [
  ["path", { d: "M2 22h8v-2H2zM4 20V8h4v12M4 9l4 5-4 5M2 8V5l4-3 16 3v3z", key: "structure" }],
  ["path", { d: "M6 2v3M2 5h20M3 8l3-3 4 3 4-3 4 3 3-3", key: "jib" }],
  ["path", { d: "M19 8v7m0 0c0 2 2 1 2 3a2 2 0 0 1-4 0", key: "hook" }],
]);
